function initializeBenefitDetails() {
  // const triggers = [
  //     { selector: ".wrapper-index-1 .benefit-details", end: "bottom+=2000% bottom", y: 0 },
  //     { selector: ".wrapper-index-2 .benefit-details", end: "bottom+=150% center", y: 90 },
  //     { selector: ".wrapper-index-3 .benefit-details", end: "bottom+=300% center", y: 0 },
  //     { selector: ".wrapper-index-4 .benefit-details", end: "bottom+=150% center", y: 90 },
  // ];

  // gsap.registerPlugin(ScrollTrigger);

  // triggers.forEach(({ selector, end, y }) => {
  //     const elements = document.querySelectorAll(selector);
  //     elements.forEach((element) => {
  //         gsap.to(element, {
  //             opacity: 1,
  //             y: y,
  //             duration: 1,
  //             ease: "power2.out",
  //             scrollTrigger: {
  //                 trigger: element,
  //                 start: "top center",
  //                 end: end,
  //                 pin: true,
  //                 scrub: 2,
  //                 pinSpacing: false,
  //                 invalidateOnRefresh: true,
  //                 markers: false,
  //             },
  //         });
  //     });
  // });


  if (window.innerWidth == 1920) {
      
    var items = $(
      "body.product-rtd-pdp .product-benefits-wrapper .benefits-items .benefit-details:not(.data)"
    );

    // Benefits Text Animation
    gsap.utils.toArray(items).forEach((item) => {
      // ScrollTrigger for animation when scrolling down
      gsap.fromTo(
        item,
        {
          opacity: 0,
          y: 200,
        },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: "power3.out",
          scrollTrigger: {
            trigger: item,
            start: "top 85%", // Stop animation when the element is fully out of view
            toggleActions: "play none none none", // Play animation once
            markers: false, // Optionally turn off markers for debugging
          },
        }
      );
    });
    const benefits = $('.product--left .product-benefits-wrapper .benefits-main .benefits-items');

    if(benefits.length > 0){

      // Access them individually
      const firstBenefit = benefits[0].querySelector(".benefit-details"); // First benefit
      const secondBenefit = benefits[1].querySelector(".benefit-details"); // Second benefit

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: firstBenefit,
          start: "top center",
          end: "bottom+=1700% bottom",
          pin: true,
          scrub: 2,
          pinSpacing: false,
          invalidateOnRefresh: true,
          markers: false,
        },
      });

      tl.to(firstBenefit, {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: "power2.out",
      });

      tl.to(secondBenefit, {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: secondBenefit,
          start: "top center",
          end: "bottom+=200% center",
          pin: true,
          scrub: 2,
          pinSpacing: false,
          // invalidateOnRefresh: true,
          markers: false,
        },
      });
    }


    const benefitsl = $('body.product-rtd-pdp .product-benefits-wrapper .benefits-main .current');
    if(benefitsl.length > 0){
      // Access them individually
      const firstBenefitl = benefitsl[0].querySelector(".benefit-details"); // First benefit
      const secondBenefitl = benefitsl[1].querySelector(".benefit-details"); // Second benefit
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: firstBenefitl,
          start: "top+=100% center",
          end: "bottom+=1200% bottom",
          pin: true,
          scrub: 2,
          pinSpacing: false,
          invalidateOnRefresh: true,
          markers: false,
        },
      });
      $(firstBenefitl).each(function () {
        const it = this;
        tl.to(it, {
          opacity: 1,
          y: 90,
          duration: 1,
          ease: "power2.out",
          scrollTrigger: {
            trigger: it,
            start: "top center",
            end: "bottom+=310% center",
            pin: true,
            scrub: 2,
            pinSpacing: false,
            // invalidateOnRefresh: true,
            markers: false,
          },
        });
      });
      $(secondBenefitl).each(function () {
        const it = this;
        tl.to(it, {
          opacity: 1,
          y: 90,
          duration: 1,
          ease: "power2.out",
          scrollTrigger: {
            trigger: it,
            start: "top center",
            end: "bottom+=220% center",
            pin: true,
            scrub: 2,
            pinSpacing: false,
            // invalidateOnRefresh: true,
            markers: false,
          },
        });
      });
    }
  }else{
    var items = $( "body.product-rtd-pdp .product-benefits-wrapper .benefits-items .benefit-details:not(.data)" );
    gsap.utils.toArray(items).forEach((item) => {
      gsap.fromTo(
        item,
        {
          opacity: 0,
          y: 50,
        },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: "power3.out",
          scrollTrigger: {
            trigger: item,
            start: "top 85%", // Stop animation when the element is fully out of view
            toggleActions: "play none none none", // Play animation once
            markers: false, // Optionally turn off markers for debugging
          },
        }
      );
    });

    const benefits = $('.product--left .product-benefits-wrapper .benefits-main .benefits-items');

    if(benefits.length > 0){
      // Access them individually
      const firstBenefit = benefits[0].querySelector(".benefit-details"); // First benefit
      const secondBenefit = benefits[1].querySelector(".benefit-details"); // Second benefit
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: firstBenefit,
          start: "top+=100% center",
          end: "bottom+=1200% bottom",
          pin: true,
          scrub: 2,
          pinSpacing: false,
          invalidateOnRefresh: true,
          markers: false,
        },
      });
      

      tl.to(firstBenefit, {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: "power2.out",
      });

      tl.to(secondBenefit, {
        opacity: 1,
        y: 0,
        duration: 1,
        ease: "power2.out",
        scrollTrigger: {
          trigger: secondBenefit,
          start: "top center",
          end: "bottom+=260% center",
          pin: true,
          scrub: 2,
          pinSpacing: false,
          markers: false,
        },
      });
    }

    const benefitsl = $('body.product-rtd-pdp .product-benefits-wrapper .benefits-main .current');
    if(benefitsl.length > 0){
      // Access them individually
      const firstBenefitl = benefitsl[0].querySelector(".benefit-details"); // First benefit
      const secondBenefitl = benefitsl[1].querySelector(".benefit-details"); // Second benefit
      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: firstBenefitl,
          start: "top+=100% center",
          end: "bottom+=1200% bottom",
          pin: true,
          scrub: 2,
          pinSpacing: false,
          invalidateOnRefresh: true,
          markers: false,
        },
      });

      $(firstBenefitl).each(function () {
        const it = this;
        tl.to(it, {
          opacity: 1,
          y: 90,
          duration: 1,
          ease: "power2.out",
          scrollTrigger: {
            trigger: it,
            start: "top center",
            end: "bottom+=200% center",
            pin: true,
            scrub: 2,
            pinSpacing: false,
            markers: false,
          },
        });
      });
      $(secondBenefitl).each(function () {
        const it = this;
        tl.to(it, {
          opacity: 1,
          y: 90,
          duration: 1,
          ease: "power2.out",
          scrollTrigger: {
            trigger: it,
            start: "top center",
            end: "bottom+=190% center",
            pin: true,
            scrub: 2,
            pinSpacing: false,
            markers: false,
          },
        });
      });
    }
  }
}


(function () {
  const PDPcanvas = document.getElementById("product-canvas");
  const imageContainer = document.querySelector(".product-container");
  const scrollTriggerElement = document.querySelector(".scroll-content");
  const PDPctx = PDPcanvas ? PDPcanvas.getContext("2d") : null;
  let frameCount = 0;
  const images = [];

  function preloadFrames(frames) {
    images.length = 0;
    let imagesLoaded = 0;
    frames.forEach((src, index) => {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        imagesLoaded++;
        if (imagesLoaded === frames.length) {
          drawFrame(0);
          initializeScrollTrigger();
          imageContainer.classList.add("animated-ready");
          document.body.classList.add("js-canvas-animation-ready");
          initializeMobileSwipe(frames);
          
        }
      };
      images[index] = img;
    });
  }

  function drawFrame(frameIndex) {
    const imageToDraw = images[frameIndex];
    if (imageToDraw && imageToDraw.complete) {
      const canvas = PDPcanvas;
      PDPctx.clearRect(0, 0, canvas.width, canvas.height);
      const imgAspectRatio = imageToDraw.width / imageToDraw.height;
      const canvasAspectRatio = canvas.width / canvas.height;
      let drawWidth, drawHeight;
      if (imgAspectRatio > canvasAspectRatio) {
        drawWidth = canvas.width;
        drawHeight = canvas.width / imgAspectRatio;
      } else {
        drawHeight = canvas.height;
        drawWidth = canvas.height * imgAspectRatio;
      }
      const x = (canvas.width - drawWidth) / 2;
      const y = (canvas.height - drawHeight) / 2;
      PDPctx.drawImage(imageToDraw, x, y, drawWidth, drawHeight);
    } else {
      console.warn(`Image at frame ${frameIndex} is not loaded yet.`);
    }
  }

  function initializeScrollTrigger() {
    if (ScrollTrigger.getById("productScroll")) {
      ScrollTrigger.getById("productScroll").kill();
    }
    if (!window.theme.is_rtd_template) return;
    const breakpoints = {
      1920: { yOffset: 200 },
      1536: { yOffset: 250 },
      1366: { yOffset: 250 },
      1280: { yOffset: 250 },
      1024: { yOffset: 50 },
    };
    const currentBreakpoint = breakpoints[window.innerWidth] || { yOffset: 50 };
    const yOffset = currentBreakpoint.yOffset;

    gsap.registerPlugin(ScrollTrigger);

    const items = document.querySelectorAll(
      "body.product-rtd-pdp .product-benefits-wrapper .benefits-items .benefit-details:not(.data)"
    );
    items.forEach((item) => {
      gsap.fromTo(
        item,
        { opacity: 0, y: yOffset },
        {
          opacity: 1,
          y: 0,
          duration: 1,
          ease: "power3.out",
          scrollTrigger: {
            trigger: item,
            start: "top 85%",
            toggleActions: "play none none none",
          },
        }
      );
    });

    $(document).ready(function(){
     initializeBenefitDetails(); // Ensure benefit details are initialized.
});

    const scene = { frame: 0 };
    gsap
      .timeline({
        id: "productScroll",
        scrollTrigger: {
          trigger: scrollTriggerElement,
          start: "top-=250px top",
          end: "bottom+=1000px bottom",
          scrub: 1,
        },
      })
      .to(scene, {
        frame: frameCount - 1,
        ease: "none",
        snap: "frame",
        onUpdate: () => {
          const frameIndex = Math.max(0, Math.floor(scene.frame));
          drawFrame(frameIndex);
        },
      });
  }

  function initializeMobileSwipe(frames) {
    if (!/iPhone|iPad|iPod|Android/i.test(navigator.userAgent)) return;
    const rotatingImage = document.querySelector("img.product-featured_image");
    let currentFrame = 0;
    let isDragging = false;
    let startX = 0;
    let accumulatedDeltaX = 0;
    const pixelsPerFrame = 12;

    rotatingImage.src = frames[0];

    function handleSwipe(pageX) {
      const deltaX = pageX - startX;
      accumulatedDeltaX += deltaX;
      startX = pageX;
      const frameChange = Math.floor(accumulatedDeltaX / pixelsPerFrame);
      if (frameChange !== 0) {
        accumulatedDeltaX = 0;
        currentFrame =
          (currentFrame - frameChange + frames.length) % frames.length;
        rotatingImage.src = frames[currentFrame];
      }
    }

    rotatingImage.addEventListener("touchstart", (e) => {
      isDragging = true;
      startX = e.touches[0].pageX;
      accumulatedDeltaX = 0;
    });

    rotatingImage.addEventListener("touchmove", (e) => {
      if (isDragging) handleSwipe(e.touches[0].pageX);
    });

    rotatingImage.addEventListener("touchend", () => {
      isDragging = false;
    });
  }

  function initializeAnimation() {
    const selectedVariant = variantFrames.find((v) => v.selected);
    if (selectedVariant) {
      const { frames } = selectedVariant;
      window.theme.product_animation_frames = frames;
      frameCount = frames.length;
      preloadFrames(frames);
    } else {
      console.warn("No selected variant found.");
    }
  }

  if (PDPcanvas) {
    initializeAnimation();
  }

  document.addEventListener("myCustomEvent", (e) => {
    const currentVariant = e.detail;
    const variantData = variantFrames.find(
      (v) => v.variant === currentVariant.id
    );
    if (variantData) {
      window.theme.product_animation_frames = variantData.frames;
      frameCount = variantData.frames.length;
      preloadFrames(variantData.frames);
    }
  });
})();
